import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";

import "./registerServiceWorker";
import swalOptions from "@/shared/utils";

//custom plugings
import { filters } from "./filters/common";
import i18n from "@/plugins/i18n";
import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import lodash from "lodash";
import VueLodash from "vue-lodash";
import VueDragDrop from "vue-drag-drop";
import LiquorTree from "liquor-tree";

import PrettyCheckbox from "pretty-checkbox-vue";
import DatePicker from "vue2-datepicker";
import CKEditor from "@ckeditor/ckeditor5-vue";
import "@ckeditor/ckeditor5-build-classic/build/translations/ja.js";
import VModal from "vue-js-modal";
/*register global filters*/
Object.keys(filters).forEach((k) => Vue.filter(k, filters[k]));

Vue.use(VModal, {
  dynamicDefaults: {
    draggable: true,
    resizable: true,
    height: "auto",
  },
});
Vue.use(VueSweetalert2, swalOptions);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);

Vue.use(VueLodash, lodash);
Vue.use(VueDragDrop);
Vue.use(PrettyCheckbox);
Vue.use(LiquorTree);
Vue.use(CKEditor);
//global component
Vue.component("DatePicker", DatePicker);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
